export default __webpack_public_path__ + "static/media/plus.1c7aaf12.svg";